import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-satisfaction',
	templateUrl: './satisfaction.component.html',
	styleUrls: ['./satisfaction.component.scss']
})
export class SatisfactionComponent implements OnChanges {
	satisfactionRate = 88.88;
	satisfactionRateLpc = 88.88;
	satisfactionRateLds = 88.88;
	satisfactionRatepdn = 88.88;
	satisfactionRateOral = 88.88;
	satisfactionRateSAAD = 88.88;

	@Input() globalStats?: any;
	@Input() lsfStats?: any;
	@Input() lpcStats?: any;
	@Input() pdnStats?: any;
	@Input() oralStats?: any;
	// @Input() pdnStats: any;

	chartOptionSatisfactionLSF: EChartsOption;
	chartOptionSatisfactionLPC: EChartsOption;
	chartOptionSatisfactionPDN: EChartsOption;
	chartOptionSatisfactionOral: EChartsOption;
	chartOptionSatisfactionSAAD: EChartsOption;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}
	// ngOnInit(): void {}

	ngOnChanges(changes: any): void {
		if (isNaN(this.globalStats) && this.globalStats) {
			try {
				this.updateSatisfactionRate();
			} catch (error) {}
		}
	}

	updateSatisfactionRate() {
		if (isNaN(this.globalStats) && this.globalStats) {
			this.satisfactionRate = 88.888;
			const rateGlobal = this.globalStats.numberFormation
				? 1 -
				  this.globalStats.numberSpeNoRespecte /
						this.globalStats.numberFormation
				: 1;

			this.satisfactionRate = 100.0 * rateGlobal;

			if (
				this.isSESSAD &&
				isNaN(this.pdnStats) &&
				isNaN(this.lsfStats) &&
				isNaN(this.lpcStats) &&
				isNaN(this.oralStats)
			) {
				const rateLpc = this.lpcStats.numberFormation
					? 1 -
					  this.lpcStats.numberSpeNoRespecte / this.lpcStats.numberFormation
					: 1;
				this.satisfactionRateLpc = 100.0 * rateLpc;

				const rateLds =
					this.lsfStats.numberFormation > 0
						? 1 -
						  this.lsfStats.numberSpeNoRespecte / this.lsfStats.numberFormation
						: 1;
				this.satisfactionRateLds = 100.0 * rateLds;

				const ratepdn =
					this.pdnStats.numberFormation > 0
						? 1 -
						  this.pdnStats.numberSpeNoRespecte / this.pdnStats.numberFormation
						: 1;
				this.satisfactionRatepdn = 100.0 * ratepdn;

				const rateOral =
					this.oralStats.numberFormation > 0
						? 1 -
						  this.oralStats.numberSpeNoRespecte /
								this.oralStats.numberFormation
						: 1;
				this.satisfactionRateOral = 100.0 * rateOral;

				this.chartOptionSatisfactionLPC = {
					title: [
						{
							text: '' + this.satisfactionRateLpc.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'LPC',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LPC',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateLpc,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations LPC satisfaites'
								},
								{
									value: 100 - this.satisfactionRateLpc,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations LPC insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};
				this.chartOptionSatisfactionLSF = {
					title: [
						{
							text: '' + this.satisfactionRateLds.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'LSF',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LSF',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateLds,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations LSF satisfaites'
								},
								{
									value: 100 - this.satisfactionRateLds,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations LSF insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};

				this.chartOptionSatisfactionPDN = {
					title: [
						{
							text: '' + this.satisfactionRatepdn.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'Prise de notes',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LPC',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRatepdn,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations Prise de notes satisfaites'
								},
								{
									value: 100 - this.satisfactionRatepdn,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations Prise de notes insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};

				this.chartOptionSatisfactionOral = {
					title: [
						{
							text: '' + this.satisfactionRateOral.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_VIOLET
							}
						},
						{
							text: 'Oral',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_VIOLET
							}
						}
					],
					tooltip: {
						show: false
					},
					calculable: true,
					series: [
						{
							name: 'Oral',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateLpc,
									itemStyle: { color: THEME_COLOR_VIOLET },
									name: 'Formations Oral satisfaites'
								},
								{
									value: 100 - this.satisfactionRateLpc,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations Oral insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};
			} else if (this.isSAAD) {
				const rateSAAD = this.globalStats?.numberFormation
					? 1 -
					  this.globalStats?.numberSpeNoRespecte /
							this.globalStats?.numberFormation
					: 1;
				this.satisfactionRateSAAD = 100.0 * rateSAAD;

				this.chartOptionSatisfactionSAAD = {
					title: [
						{
							text: '' + this.satisfactionRateSAAD.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'Aide à domicile',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'Aide à domicile',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateSAAD,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Prestations satisfaites'
								},
								{
									value: 100 - this.satisfactionRateSAAD,
									itemStyle: { color: '#FFFFFF' },
									name: 'Prestations insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};
			}
		}
	}
}
